import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../services/local-storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adv-header-before-signup',
  templateUrl: './adv-header-before-signup.component.html',
})
export class AdvHeaderBeforeSignupComponent implements OnInit {

  constructor(private localstorage:LocalStorage,private router:Router) { }

  ngOnInit() {
  }
     redirectpage() {
     var token=this.localstorage.getStorage('token');
     if(token) {
    this.router.navigate(['advertiser/campaignlist']); 
     }
     else {
       this.router.navigate(['']); 
     } 
  }

}



// WEBPACK FOOTER //
// ./src/app/common/adv-header-before-signup.component.ts